import PromoSection from './PromoSection'

export default PromoSection